/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ResponseEnterpriseGetListMeta } from './ResponseEnterpriseGetListMeta'
import {
  ResponseEnterpriseGetListMetaFromJSON,
  ResponseEnterpriseGetListMetaFromJSONTyped,
  ResponseEnterpriseGetListMetaToJSON,
  ResponseEnterpriseGetListMetaToJSONTyped,
} from './ResponseEnterpriseGetListMeta'

/**
 *
 * @export
 * @interface ResponseOrderGetSums
 */
export interface ResponseOrderGetSums {
  /**
   *
   * @type {boolean}
   * @memberof ResponseOrderGetSums
   */
  success: boolean
  /**
   * Object of sums in shops/shopSalePoints/shopPaymentPoints. Key = shopId/shopSalePointId/shopPaymentPointId, value = sum
   * @type {{ [key: string]: string; }}
   * @memberof ResponseOrderGetSums
   */
  data?: { [key: string]: string }
  /**
   *
   * @type {ResponseEnterpriseGetListMeta}
   * @memberof ResponseOrderGetSums
   */
  meta?: ResponseEnterpriseGetListMeta
  /**
   *
   * @type {string}
   * @memberof ResponseOrderGetSums
   */
  errorMessage?: string
  /**
   *
   * @type {number}
   * @memberof ResponseOrderGetSums
   */
  codeError?: number
}

/**
 * Check if a given object implements the ResponseOrderGetSums interface.
 */
export function instanceOfResponseOrderGetSums(
  value: object,
): value is ResponseOrderGetSums {
  if (!('success' in value) || value['success'] === undefined) return false
  return true
}

export function ResponseOrderGetSumsFromJSON(json: any): ResponseOrderGetSums {
  return ResponseOrderGetSumsFromJSONTyped(json, false)
}

export function ResponseOrderGetSumsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseOrderGetSums {
  if (json == null) {
    return json
  }
  return {
    success: json['success'],
    data: json['data'] == null ? undefined : json['data'],
    meta:
      json['meta'] == null
        ? undefined
        : ResponseEnterpriseGetListMetaFromJSON(json['meta']),
    errorMessage:
      json['errorMessage'] == null ? undefined : json['errorMessage'],
    codeError: json['codeError'] == null ? undefined : json['codeError'],
  }
}

export function ResponseOrderGetSumsToJSON(json: any): ResponseOrderGetSums {
  return ResponseOrderGetSumsToJSONTyped(json, false)
}

export function ResponseOrderGetSumsToJSONTyped(
  value?: ResponseOrderGetSums | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    success: value['success'],
    data: value['data'],
    meta: ResponseEnterpriseGetListMetaToJSON(value['meta']),
    errorMessage: value['errorMessage'],
    codeError: value['codeError'],
  }
}
